import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStairsDowninline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M60 60H4",
				fill: "#FFE0E0",
				opacity: .654
			}),
			/* @__PURE__ */ _jsx("path", { d: "M0 0h64v64H0z" }),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				d: "M59 59V47H46V35H32V23H19V11H5"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51 21L41 11",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "square",
				strokeLinejoin: "round",
				d: "M43 21h8v-8"
			})
		]
	})
});
export default SvgStairsDowninline;
